import styled from 'styled-components';

export const CellWrapper = styled.div`
  height: 48.5px;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
